import styled, { css } from 'styled-components';
import { StyledRteHtmlText } from './StyledRteHtmlText.tsx';

/**
 * Permette di renderizzare un testo HTML generato dal componente RichTextInput
 * con gli stili di default del progetto.
 * @param inline se true, il testo viene visualizzato in linea (il tag html <p>)
 */
export const StyledHtmlText = styled.span<{ inline?: boolean }>`
  &&& {
    ${StyledRteHtmlText}
    ${props =>
      props.inline &&
      css`
        display: inline;
        margin-bottom: 0;

        p,
        span.paragraph-title {
          display: inline;
          margin-right: 0.25em;
          margin-bottom: 0;
          &:last-child {
            margin-right: 0;
          }
        }
      `}
  }
`;
